import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '电视剧', path: '/category/tv-series' },
  { label: '电影', path: '/category/movies' },
  { label: '综艺', path: '/category/variety' },
  { label: '动漫', path: '/category/anime' },
  { label: '资讯', path: '/category/news' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(isHome ? window.scrollY > 60 : true);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHome]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 text-xl md:text-2xl font-heading font-semibold whitespace-nowrap cursor-pointer"
            style={{ color: scrolled ? 'oklch(var(--primary-500))' : 'oklch(var(--background-50))' }}
          >
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">红</span>
            红桃视频
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? scrolled
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-white/20 text-background-50'
                    : scrolled
                      ? 'text-foreground-600 hover:text-primary-600 hover:bg-primary-50'
                      : 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/tv-series"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                scrolled ? 'text-foreground-600 hover:text-primary-600' : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              登录
            </Link>
            <Link
              to="/category/tv-series"
              className="px-5 py-2 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              立即加入
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-xl transition-colors ${
                scrolled ? 'text-foreground-800' : 'text-background-50'
              } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            />
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 rounded-lg shadow-lg mx-1 mb-3 overflow-hidden animate-in slide-in-from-top-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-4 py-3 text-sm font-medium border-b border-background-100 last:border-b-0 transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex items-center gap-3 px-4 py-3 border-t border-background-100">
              <Link
                to="/category/tv-series"
                className="text-sm font-medium text-foreground-600 hover:text-primary-600 whitespace-nowrap cursor-pointer"
              >
                登录
              </Link>
              <Link
                to="/category/tv-series"
                className="px-5 py-2 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 whitespace-nowrap cursor-pointer"
              >
                立即加入
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}